<template>
  <v-content id="liver-content">
    <v-tabs background-color="#6CBFEB" v-model="page" dark slider-color="yellow" centered>
      <v-tab v-for="(_, grad) in typedLivers" :key="grad" ripple>
        {{grad}}
      </v-tab>
      <v-tab-item v-for="(livers, grad) in typedLivers" :key="grad">
        <v-list three-line>
          <LiverView v-for="liver in livers" :liver="liver" :key="liver.id"></LiverView>
        </v-list>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-model="isLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-title color="white">
          loading...
        </v-card-title>
        <v-progress-linear indeterminate color="cyan"></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<style scoped>
  #liver-content {
    padding-top: 0px !important;
    padding-left: 0px !important;
  }
</style>

<script>
import LiverView from '@/components/LiverView.vue'
import store from '@/util/store.js'
import { grad } from '@/util/config.js'

  export default {
    components: { LiverView },
    data: () => ({
      isLoading: false,
      page: 0
    }),

    props: {
    },

    created() {
    },

    mounted() {
    },

    computed: {
      typedLivers: function() {
        return store.state.livers.reduce((acc, liver) => {
          if(!acc[grad[liver.graduation]]) {
            acc[grad[liver.graduation]] = [];
          }
          acc[grad[liver.graduation]].push(liver);
          return acc;
        }, {});
      }
    },
  }
</script>
